import { render } from "./AddContrat.vue?vue&type=template&id=536c7174&scoped=true&ts=true"
import script from "./AddContrat.vue?vue&type=script&lang=ts"
export * from "./AddContrat.vue?vue&type=script&lang=ts"

import "./AddContrat.vue?vue&type=style&index=0&id=536c7174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536c7174"]])

export default __exports__